<template>
    <div class="delta" :class="delta.tone">
        <template v-if="delta.plain">{{ delta.main }}</template>
        <b v-else title="Относительное изменение к датам в блоке «Сравниваем»">{{ delta.main }}</b>
        <span v-if="delta.extra" :title="delta.extraTitle || null">{{ delta.extra }}</span>
    </div>
</template>

<script>
export default {
    name: 'MetricDelta',
    props: {
        delta: { type: Object, required: true },
    },
}
</script>
